import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=03403fe0&scoped=true&"
import script from "./stock.vue?vue&type=script&lang=js&"
export * from "./stock.vue?vue&type=script&lang=js&"
import style0 from "./stock.vue?vue&type=style&index=0&id=03403fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03403fe0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03403fe0')) {
      api.createRecord('03403fe0', component.options)
    } else {
      api.reload('03403fe0', component.options)
    }
    module.hot.accept("./stock.vue?vue&type=template&id=03403fe0&scoped=true&", function () {
      api.rerender('03403fe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/stock.vue"
export default component.exports